/*
 * 请求封装库
 * @Author: Evan.Xu 
 * @Date: 2020-05-25 16:18:30 
 * @Last Modified by: Evan.Xu
 * @Last Modified time: 2020-11-05 11:30:47
 */
import axios from 'axios';
import { accountStore } from '@/store/account';
import router from '@/router';
import { notification } from 'ant-design-vue';
import qs from 'qs';
import { signParams } from './utils';
import { generateUUID } from '@/core/utils';

// 创建axios实例
const service = axios.create({
  timeout: 1000 * 6 // 请求超时时间
});

// 错误信息整合
const err = (error) => {
  // 不同错误情况做不同提示与操作
  if (error.response) {
    // console.log('error', error.response);
    const _err = error.response;
    const token = accountStore().accessToken;
    // 判断状态 error.response.status（如：403、401、未登录 等）
    if (_err.status === 403) {
      notification.error({
        message: 'Forbidden error',
        description: _err.data.message,
      });
    }
    if (_err.status === 401) {
      notification.error({
        message: 'Unauthorized error',
        description: 'Authorization verification failed',
      });
      if (token) {
        accountStore().Logout()
          .then(() => {
            setTimeout(() => {
              window.location.reload();
            }, 1500);
          })
          .catch((err) => {
            console.log(`接口请求异常：${err}`);
          });
      }
    }
  }
  // 网络异常
  if (error.message === 'Network Error') {
    notification.error({
      message: 'Forbidden error',
      description: error.message,
    });
  }
  return Promise.reject(error);
};

// 配置header
// service.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
// service.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
// service.defaults.headers.put['Content-Type'] = 'application/x-www-form-urlencoded';

// request interceptor
service.interceptors.response.use((response) => {
  // 判断状态 response.data.code（如：201 等）做鉴权操作
  // console.log('request', response.data);
  // token失效 | 未登录 ｜ 无权限
  if (response.data.code === 110) {
    accountStore().accessToken = '';
    notification.error({
      message: 'Token error',
      description: response.data.msg,
    });
    router.push({ path: '/user/login', query: { redirect: router.currentRoute.value.fullPath } });
  } else if (response.data.code === 114) {
    router.push({ name: '403'});
  }
  return response.data;
}, err);

service.interceptors.request.use(config => {
  let timestamp = Number(new Date());
  config.headers['applet-token'] = signParams({ path: config.url, timestamp });
  config.headers['trace-id'] = generateUUID().replace(/-/g, '');
  if (config.method === 'get') {
    config.params = Object.assign(config.params, { timestamp_private: timestamp });
  } else if (config.method === 'post') {
    if (config.data instanceof FormData) {
      config.data.append('timestamp_private', timestamp);
    } else {
      let formatData = qs.parse(config.data);
      formatData = Object.assign(formatData, { timestamp_private: timestamp });
      config.data = qs.stringify(formatData);
    }
  }
  return config;
})
export default service;